<template>
  <img @click="onLinkedInLoad()" src="/vue/images/linkedin.png">
</template>
<script>
import functions from "./functions.js";

export default {
  mixins: [functions],
  methods: {
    onLinkedInLoad() {
      IN.UI.Authorize().place();
      IN.Event.on(IN, "auth", () => {
        this.onLogin();
      });
      IN.Event.on(IN, "logout", () => {
        this.onLogout();
      });
    },
    onLogin() {
      IN.API.Profile("me")
        .fields(
          "id",
          "first-name",
          "last-name",
          "headline",
          "location",
          "picture-url",
          "public-profile-url",
          "email-address"
        )
        .result(this.displayResult);
    },
    displayResult(profiles) {
      let profile = profiles.values[0];
      this.socLogin(
        profile.firstName,
        profile.lastName,
        profile.id,
        profile.pictureUrl,
        profile.emailAddress,
        "linkedin"
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/js/components/social/linkedin.vue